import { Fragment, useState } from 'react';
import { Chip, Divider, List, ListItem, ListItemButton, ListItemText, Stack } from '@mui/material';
import dayjs from 'dayjs';
import WaiverSignatureModal from './WaiverSignatureModal';

// Renders waivers of one booking. Clicking an entry opens the signature.
export default function WaiverList({ waivers = [], dense = false }) {
  const [selectedWaiver, setSelectedWaiver] = useState(null);

  return (
    <>
      <List dense={dense} disablePadding>
        {waivers.map((waiver, index) => {
          const children = Array.isArray(waiver.children) ? waiver.children : [];
          const signedAt = waiver.createdAt
            ? dayjs(waiver.createdAt).format('DD.MM.YYYY HH:mm')
            : '';

          return (
            <Fragment key={waiver._id}>
              {index > 0 && <Divider component='li' />}
              <ListItem disablePadding>
                <ListItemButton onClick={() => setSelectedWaiver(waiver)}>
                  <ListItemText
                    primary={
                      <Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap'>
                        <span>{waiver.lastName + ', ' + waiver.firstName}</span>
                        {waiver.source === 'online' ? (
                          <Chip label='vorab' size='small' color='success' variant='outlined' />
                        ) : (
                          <Chip
                            label={waiver.lane ? `Bahn ${waiver.lane}` : 'vor Ort'}
                            size='small'
                            variant='outlined'
                          />
                        )}
                      </Stack>
                    }
                    secondary={[
                      signedAt ? `${signedAt} Uhr` : null,
                      waiver.mail || null,
                      children.length
                        ? `+ ${children.map(child => child.firstName).join(', ')}`
                        : null,
                    ]
                      .filter(Boolean)
                      .join(' · ')}
                  />
                </ListItemButton>
              </ListItem>
            </Fragment>
          );
        })}
      </List>
      <WaiverSignatureModal
        waiver={selectedWaiver}
        open={!!selectedWaiver}
        onClose={() => setSelectedWaiver(null)}
      />
    </>
  );
}
